import { Container, Row, Col, Image, Spinner, Badge } from 'react-bootstrap';
import { useAboutPage, getAboutSectionByKey } from '@/hooks/useAboutPage';
import { getAboutImage } from '@/utils/imageUrl';

const Founder = ({ sectionData: propSectionData }) => {
  const { sections, loading } = useAboutPage();
  const founderSection = propSectionData || getAboutSectionByKey(sections, 'founder');
  
  const bgColor = founderSection?.background_color || 'light';
  const bgEffect = founderSection?.background_effect || null;
  let bgClass = bgColor === 'primary' ? 'section-bg-primary' : bgColor === 'white' ? 'bg-white' : 'bg-light';
  // Apply gradient effect if selected
  if (bgColor === 'primary' && bgEffect === 'gradient') {
    bgClass = 'section-bg-primary-gradient';
  }
  
  if (loading && !propSectionData) {
    return (
      <section className={`py-5 py-lg-6 ${bgClass} about-section founder-section`}>
        <Container>
          <div className="text-center py-5">
            <Spinner animation="border" variant="primary" />
          </div>
        </Container>
      </section>
    );
  }
  
  const founderItem = founderSection?.items?.[0];
  
  if (!founderSection) {
    return null;
  }
  
  const content = founderSection?.intro_text || founderSection?.content?.content || '';
  const imageUrl = founderItem?.image ? getAboutImage(founderItem.image) : null;
  
  // Parse content into paragraphs (split by \n\n)
  const paragraphs = content ? content.split('\n\n').filter(p => p.trim()) : [];
  const hasDotsEffect = bgColor === 'primary' && bgEffect === 'dots';
  
  return (
    <section className={`py-4 py-lg-5 ${bgClass} about-section founder-section ${hasDotsEffect ? 'position-relative overflow-hidden' : ''}`}>
      {hasDotsEffect && (
        <>
          <span className="section-bg-dots section-bg-dots--left d-none d-xl-block" />
          <span className="section-bg-dots section-bg-dots--right d-none d-lg-block" />
        </>
      )}
      <Container className={hasDotsEffect ? 'position-relative' : ''}>
        <Row className="g-4">
          <Col>
            {founderSection.subtitle && (
              <Badge bg="primary" className="bg-opacity-10 text-primary mb-3 px-3 py-2">
                {founderSection.subtitle}
              </Badge>
            )}
            {founderSection.title && (
              <h2 className="sec-title mb-4">{founderSection.title}</h2>
            )}
          </Col>
        </Row>
        <Row className="g-4 align-items-start founder-intro-row">
          {/* First 2 paragraphs share row with image (7/5 ratio - text wider) */}
          {paragraphs.length > 0 && (
            <>
              <Col md={7} lg={imageUrl ? 7 : 12}>
                <div className="founder-content">
                  {paragraphs.length >= 3 ? (
                    <p 
                      className="intro-text mb-0"
                      dangerouslySetInnerHTML={{ __html: `${paragraphs[0]}<br/><br/>${paragraphs[1]}<br/><br/>${paragraphs[2]}` }} 
                    />
                  ) : paragraphs.length >= 2 ? (
                    <p 
                      className="intro-text mb-0"
                      dangerouslySetInnerHTML={{ __html: `${paragraphs[0]}<br/><br/>${paragraphs[1]}` }} 
                    />
                  ) : (
                    <p 
                      className="intro-text mb-0"
                      dangerouslySetInnerHTML={{ __html: paragraphs[0] }} 
                    />
                  )}
                </div>
              </Col>
              {imageUrl && (
                <Col md={5} lg={5} className="d-flex justify-content-center">
                  <div className="founder-image-wrapper">
                    <Image 
                      src={imageUrl} 
                      className="founder-image" 
                      alt="George Mavrakis - Founder" 
                    />
                  </div>
                </Col>
              )}
            </>
          )}
        </Row>
        {/* Remaining paragraphs full width */}
        {paragraphs.length > 3 && (
          <Row className="g-4 mt-0">
            <Col>
              <div className="founder-content-full">
                {paragraphs.slice(3).map((paragraph, idx) => (
                  <p 
                    key={idx + 3} 
                    className={`intro-text ${idx === paragraphs.slice(3).length - 1 ? 'mb-0' : 'mb-3'}`}
                    dangerouslySetInnerHTML={{ __html: paragraph }} 
                  />
                ))}
              </div>
            </Col>
          </Row>
        )}
      </Container>
    </section>
  );
};

export default Founder;
